import { ExpandMore } from '@mui/icons-material';
import InsertInvitationRoundedIcon from '@mui/icons-material/InsertInvitationRounded';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewPostStyledComponent } from 'src/pages/new-post-new/newPostStyled.component';
import { CommonFunction } from 'src/utils/commonFunctions/common-function.component';
import { CommonHelper } from 'src/utils/commonHelper';
import GBusinessPreviewOrganize from './gbusiness-preview-organize.component';

const GBusinessPreview = ({ postDetails, isOrgEvent }) => {
  const { t: translate } = useTranslation();
  const [previewData, setPreviewData] = useState(null);
  const orgDetails = CommonHelper.GetBrandInfoFromLocalStorage();
  const [expanded, setExpanded] = useState(() => {
    const initialExpandedState = {};
    if (previewData) {
      Object.keys(previewData).forEach((profileId) => {
        initialExpandedState[profileId] = true;
      });
    }
    return initialExpandedState;
  });
  const theme = useTheme();
  useEffect(() => {
    processPreview();
  }, [postDetails]);

  const [currentTab, setCurrentTab] = useState({});

  const processPreview = () => {
    let details = CommonHelper.PreviewGroupBy(postDetails, 'connected_profile_id');
    if (isOrgEvent && details) {
      Object.keys(details).forEach((profileId) => {
        details[profileId].connected_profile_details.connected_profile_name = orgDetails?.org_name;
        details[profileId].connected_profile_details.connected_profile_image = orgDetails?.org_name;
      });
    }
    setPreviewData(details);
  };

  const handleExpand = (profileId) => (event, isExpanded) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [profileId]: isExpanded,
    }));
  };

  const handleChangeTab = (profileId, newValue) => {
    setCurrentTab((prevTabs) => ({
      ...prevTabs,
      [profileId]: newValue,
    }));
  };

  const getCurrentTab = (profileId) => {
    if (currentTab[profileId]) {
      return currentTab[profileId];
    }
    return previewData[profileId]?.data?.length > 0 && previewData[profileId].data[0].post_type;
  };

  const POST_TYPES = {
    STANDARD: {
      value: 'STANDARD',
      icon: <NewReleasesOutlinedIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      label: translate('preview.standard'),
    },
    EVENT: {
      value: 'EVENT',
      icon: <InsertInvitationRoundedIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      label: translate('preview.event'),
    },
    OFFER: {
      value: 'OFFER',
      icon: <LocalOfferOutlinedIcon sx={{ width: 25, height: 25, mb: '0 !important' }} />,
      label: translate('preview.offer'),
    },
  };
  return (
    <>
      {previewData &&
        Object.keys(previewData).map((profileId) => {
          return (
            <>
              <Accordion
                key={profileId}
                expanded={expanded[profileId] !== undefined ? expanded[profileId] : true}
                onChange={handleExpand(profileId)}
                style={{ ...NewPostStyledComponent.AccordionStyle, borderColor: theme.palette.text.border }}
              >
                <AccordionSummary expandIcon={<ExpandMore />} sx={NewPostStyledComponent.AccordionSummary}>
                  <Grid alignItems="center" display="flex">
                    {isOrgEvent
                      ? CommonFunction.SocialMediaBadgeWithName(previewData[profileId]?.connected_profile_details)
                      : CommonFunction.AccountBadgeWithName(previewData[profileId]?.connected_profile_details)}
                  </Grid>
                </AccordionSummary>
                <Divider />
                <AccordionDetails style={{ padding: '0.5rem' }}>
                  <Box>
                    <Tabs
                      value={currentTab[profileId] ? currentTab[profileId] : getCurrentTab(profileId)}
                      onChange={(e, newValue) => handleChangeTab(profileId, newValue)}
                      scrollButtons="auto"
                      variant="scrollable"
                      sx={{ gap: '0.5rem', minHeight: '37px', margin: '1rem' }}
                    >
                      {previewData[profileId]?.data?.length > 0 &&
                        previewData[profileId].data.map((post) => {
                          return (
                            <Tab
                              sx={{
                                flexDirection: 'row',
                                gap: '0.25rem',
                                padding: 0,
                                minHeight: '10px',
                                mr: '0.75rem',
                                fontWeight: 600,
                              }}
                              disableRipple
                              key={POST_TYPES[post.post_type].value}
                              label={POST_TYPES[post.post_type].label}
                              icon={POST_TYPES[post.post_type].icon}
                              value={POST_TYPES[post.post_type].value}
                            />
                          );
                        })}
                    </Tabs>
                    <Box sx={{ mb: 2 }} />
                    <GBusinessPreviewOrganize
                      postType={getCurrentTab(profileId)}
                      previewData={previewData}
                      profileId={profileId}
                    />
                  </Box>
                </AccordionDetails>
              </Accordion>
            </>
          );
        })}
    </>
  );
};

export default GBusinessPreview;
